/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ReservedBloodProductsRestartAliases {
  DATE_FIELD = 'date-field',
  DATE_INPUT = 'date-input',
  INFUSION_SPEED_FIELD = 'infusion-speed-field',
  INFUSION_SPEED_INPUT = 'infusion-speed-input',
  NOTES_FIELD = 'notes-field',
  NOTES_TEXT_AREA = 'notes-text-area',
  RESERVED_BLOOD_PRODUCTS_RESTART_FORM = 'reserved-blood-products-restart-form',
  RESERVED_BLOOD_PRODUCTS_RESTART_LAYOUT = 'reserved-blood-products-restart-layout',
  RESERVED_BLOOD_PRODUCTS_RESTART_MAIN_PANEL = 'reserved-blood-products-restart-main-panel',
  SCHEDULE_DATE_FIELD = 'schedule-date-field',
  SCHEDULE_DATE_INPUT = 'schedule-date-input',
  STEP_VOLUME_FIELD = 'step-volume-field',
  STEP_VOLUME_INPUT = 'step-volume-input',
  TITLE_FIELD = 'title-field',
  TITLE_PANEL = 'title-panel',
  TITLE_TEXT = 'title-text',
  UNITY_FIELD = 'unity-field',
  UNITY_INPUT = 'unity-input',
}
export { ReservedBloodProductsRestartAliases };
